import React from "react";
import Grid from "@material-ui/core/Grid";
import backgroundImage from "../../../../assets/images/main_background.png";
class StartButton extends React.Component{
    render() {
        const {
            backgroundImage,
            text,
            icon,
            iconText,
        }=this.props.data
        return(
            <Grid justify={'center'}  xs={12} sm={12}  item container className='clickable' onClick={this.props.clicked}>
                {
                    icon &&
                    <Grid justify={'center'}  xs={12} sm={12}  item container
                          style={{
                              backgroundImage: "url(" + backgroundImage + ")",
                              backgroundRepeat: 'no-repeat',
                              backgroundSize:'100% 100%',
                          }}
                          className='green-button'
                    >
                        <Grid xs={5} sm={5} justify={"center"} container alignItems={"center"} item style={{position:'relative'}}>
                            <img className='green-button-icon' src={icon} alt=""/>
                            <p  className='green-button-icon-text'>
                                {iconText}
                            </p>
                        </Grid>
                        <Grid xs={5} sm={5} justify={"center"} container alignItems={"center"}   item>
                            <p className='green-button-text'>
                                شروع بازی
                            </p>
                        </Grid>
                    </Grid>
                }
                {
                    !icon &&
                    <Grid justify={'center'}  xs={12} sm={12}  item container
                          style={{
                              backgroundImage: "url(" + backgroundImage + ")",
                              backgroundRepeat: 'no-repeat',
                              backgroundSize:'100% 100%',
                          }}
                          className='green-button'
                    >

                        <Grid xs={10} sm={10} justify={"center"} container alignItems={"center"} item>
                            <p className='green-button-text'>
                                {text}
                            </p>
                        </Grid>
                    </Grid>
                }
                </Grid>
        )
    }
}

export default StartButton;
